import { Layout } from 'react-grid-layout';
import { CardConfig } from '../components/SettingsMenu';
import { DEFAULT_LAYOUTS } from '../constants/layoutConfigs';

const generateChartLayout = (cardId: string, index: number) => {
  // Use the original chart layout as a template but position new charts below existing content
  const baseChartLayout = DEFAULT_LAYOUTS.lg.find((item) => item.i === 'chart') || {
    i: 'chart',
    x: 4,
    y: 0,
    w: 8,
    h: 12,
    minW: 3,
    minH: 6,
  };

  // Calculate position for new chart cards (stacked vertically)
  const yOffset = index * 12; // Each chart takes 12 units height

  return {
    lg: { ...baseChartLayout, i: cardId, y: baseChartLayout.y + yOffset },
    md: { ...baseChartLayout, i: cardId, y: baseChartLayout.y + yOffset, w: 7 },
    sm: { ...baseChartLayout, i: cardId, y: baseChartLayout.y + yOffset, w: 4 },
  };
};

export const getFilteredLayouts = (cardConfigs: CardConfig[]) => {
  const enabledCards = cardConfigs.filter((config) => config.enabled);
  const enabledCardIds = enabledCards.map((config) => config.id);

  // Start with layouts for existing cards
  const baseLayouts = {
    lg: DEFAULT_LAYOUTS.lg.filter((item) => enabledCardIds.includes(item.i)),
    md: DEFAULT_LAYOUTS.md.filter((item) => enabledCardIds.includes(item.i)),
    sm: DEFAULT_LAYOUTS.sm.filter((item) => enabledCardIds.includes(item.i)),
  };

  // Add layouts for new chart cards that don't have default layouts
  const chartCards = enabledCards.filter((card) => card.type === 'chart' && card.id !== 'chart');
  chartCards.forEach((card, index) => {
    const chartLayout = generateChartLayout(card.id, index + 1); // +1 because original chart is index 0
    baseLayouts.lg.push(chartLayout.lg);
    baseLayouts.md.push(chartLayout.md);
    baseLayouts.sm.push(chartLayout.sm);
  });

  return baseLayouts;
};

export const filterSavedLayouts = (savedLayouts: any, enabledCardIds: string[]) => {
  return {
    lg: savedLayouts.lg?.filter((item: Layout) => enabledCardIds.includes(item.i)) || [],
    md: savedLayouts.md?.filter((item: Layout) => enabledCardIds.includes(item.i)) || [],
    sm: savedLayouts.sm?.filter((item: Layout) => enabledCardIds.includes(item.i)) || [],
  };
};

export const isCardEnabled = (cardConfigs: CardConfig[], cardId: string): boolean => {
  return cardConfigs.find((config) => config.id === cardId)?.enabled || false;
};
